module.exports = __webpack_public_path__ + "img/p2AR_btn_copy.43a4d014.png";